import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  QUERY_CONNECTED_DEBTORS_REQUEST,
  QUERY_CONNECTED_DEBTORS_SUCCESS,
  QUERY_CONNECTED_DEBTORS_FAILURE
} from "../types";

const handleResponse = (
  response,
  dispatch,
  groupMember,
  id,
  limit,
  ordering,
  filters
) => {
  const data = normalize(response.results, [groupMember]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(QUERY_CONNECTED_DEBTORS_SUCCESS)({
      id,
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      ordering,
      limit,
      filters
    })
  );
  return response;
};

const debounced = debounce(
  async (dispatch, schema, api, id, limit, ordering, filters) => {
    dispatch(
      createAction(QUERY_CONNECTED_DEBTORS_REQUEST)({
        id,
        limit,
        filters,
        ordering
      })
    );
    const response = await api.groups.queryConnectedDebtors(
      id,
      limit,
      ordering,
      filters
    );
    handleResponse(
      response,
      dispatch,
      schema.connectedDebtor,
      id,
      limit,
      ordering,
      filters
    );
  },
  1000,
  { trailing: true }
);

export const next = (id, link, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(QUERY_CONNECTED_DEBTORS_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.connectedDebtor,
      id,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(QUERY_CONNECTED_DEBTORS_FAILURE)(err));
    throw err;
  }
};

const queryConnectedDebtors = (id, limit, ordering, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, id, limit, ordering, filters);
  } catch (err) {
    dispatch(createAction(QUERY_CONNECTED_DEBTORS_FAILURE)(err));
    throw err;
  }
};

export default queryConnectedDebtors;
